import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NifCountriesService {

  private listNifCountries: any[] = [];


  getListNifCountries(): Observable<any[]> {
    return of(this.listNifCountries)
  }

  setListNifCountries(res: any[]): void{
    this.listNifCountries = res;
  }

}
